export const navLinks = [
  {
    id: 1,
    linkTextKey: "nav.home",
    url: "/",
  },
  {
    id: 2,
    linkTextKey: "nav.about",
    url: "/about-2",
  },
  // {
  //   id: 3,
  //   linkTextKey: "nav.services",
  //   url: "/services",
  // },
  {
    id: 4,
    linkTextKey: "nav.projects",
    url: "/projects",
  },
  {
    id: 5,
    linkTextKey: "nav.blog",
    url: "/blog-3",
  },
  {
    id: 6,
    linkTextKey: "nav.career",
    url: "/career",
  },
  {
    id: 7,
    linkTextKey: "nav.events",
    url: "/events",
  },
  {
    id: 8,
    linkTextKey: "nav.contact",
    url: "/contact",
  },
  // {
  //   id: 9,
  //   linkTextKey: "nav.pages",
  //   url: "/portifolio",
  //   subLinks: [
  //     {
  //       id: 1,
  //       linkTextKey: "nav.portfolio",
  //       url: "/portifolio",
  //     },
  //     {
  //       id: 4,
  //       linkTextKey: "nav.faqs",
  //       url: "/faqs",
  //     },
  //   ],
  // },
];
